import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { MaterialModule } from '../app.module';
import { TagInputModule } from 'ngx-chips';
import { SelectModule } from 'ng2-select';
import { TablesRoutes } from './tables.routing';

import { Longago } from '../pipes/longago.pipe';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { ExtendedTableComponent } from './extendedtable/extendedtable.component';
import { RegularTableComponent } from './regulartable/regulartable.component';
import { DataTableComponent } from './datatable.net/datatable.component';
import { ListuserComponent, NuevoPaciente } from './listuser/listuser.component';
import { ListebayitemsComponent } from './listebayitems/listebayitems.component';
import { ListlogsComponent} from './listlogs/listlogs.component';
import { ListpersonalComponent, NuevoPersonal } from './listpersonal/listpersonal.component';
import { ListpagosComponent } from './listpagos/listpagos.component';
import { ListcontactformComponent, DialogOverviewExampleDialog} from './listcontactform/listcontactform.component';


import { ListfilesComponent, NewFolder} from './listfiles/listfiles.component';
import { ListshowfilesComponent, NewSubFolder } from './listfiles/listshowfiles.component';

import { ListfilescompanyComponent, NewFoldercompany} from './listfilescompany/listfilescompany.component';
import { ListshowfilescompanyComponent, NewSubFoldercompanyFiles } from './listfilescompany/listshowfilescompany.component';
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";

import { 
  ListcompanyComponent
  ,NuevoCompany
} from './listcompany/listcompany.component';


import { DropZoneDirective } from '../drop-zone.directive';
import { Role } from '../pipes/role.pipe';
import { ContactTableComponent } from './listcontactform/contact-table/contact-table.component';
import { CompaniesTableComponent } from './listcompany/companies-table/companies-table.component';
import { ListunedainventoryComponent } from './listunedainventory/listunedainventory.component';
import { ComponentsModule } from '../shared/components/components.module';
import { ProcessignInstructionsModule } from '../processing-instructions/processing-instructions.module';

// import { AgendaModule } from '../agenda/agenda.module';
import { SharedModule } from '../shared/shared.module';
import { ContactsModule } from '../contacts/contacts.module';
import { ContactsComponent } from '../contacts/contacts.component';
import { ArchiveComponent } from './archive/archive.component';
import { PaymentrequestComponent } from './listpagos/paymetrequestmodal/paymentrequest.component';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ViewpaymentComponent } from './listpagos/viewpayment/viewpayment.component';
import { RejectpaymentComponent } from './listpagos/rejectpayment/rejectpayment.component';
import { EditpaymentComponent } from './listpagos/editpayment/editpayment.component';
import { PaymentrunComponent } from './listpagos/paymentrun/paymentrun.component';
import { ModalpayComponent } from './listpagos/modalpay/modalpay.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule.forChild(TablesRoutes),
    FormsModule,
     ReactiveFormsModule,
      NouisliderModule,
    TagInputModule,
     MaterialModule,
     ComponentsModule,
     ProcessignInstructionsModule,
     ContactsModule,
     CKEditorModule,
     MatDialogModule,
     MatIconModule,
     MatButtonModule,
     NgxSkeletonLoaderModule,
    //  AgendaModule
  ],
  entryComponents:[
    NuevoPaciente,
    NuevoPersonal,

    NewFolder,
     NuevoCompany,
    NewSubFolder,
    DialogOverviewExampleDialog,
    NewSubFoldercompanyFiles,
    NewFoldercompany,
    ContactsComponent,
    PaymentrequestComponent
  ],
  declarations: [
      ExtendedTableComponent,
      DataTableComponent,
      RegularTableComponent,
      ListuserComponent,
      ListebayitemsComponent,
      ListlogsComponent,
      ListpersonalComponent,
      ListcontactformComponent,
      ListpagosComponent,
      NuevoPaciente,
      NuevoPersonal,
      PaymentrequestComponent,
   
      ListfilesComponent,
      ListcompanyComponent,
      NewFolder,
      NuevoCompany,
      NewSubFolder,
      ListshowfilesComponent,
      DropZoneDirective,
      DialogOverviewExampleDialog,
      Role,
      ContactTableComponent,
      CompaniesTableComponent,
      NewSubFoldercompanyFiles,
    NewFoldercompany,
    ListshowfilescompanyComponent,
    ListfilescompanyComponent,
    ListunedainventoryComponent,
    Longago,
    ArchiveComponent,
    PaymentrequestComponent,
    ViewpaymentComponent,
    RejectpaymentComponent,
    EditpaymentComponent,
    PaymentrunComponent,
    ModalpayComponent
  ],
  providers: [],
  exports: [ DialogOverviewExampleDialog,PaymentrunComponent ]
})

export class TablesModule {}
